import React, { useState } from 'react';
import SelectInput from '../NewDesign/Inputs/SelectInput';
import countries from '../../../Lib/Constants/countries';
import { TextField as InternalTextField } from '../NewDesign/Inputs/TextField';
import states from '../../../Lib/Constants/states';
import AutoCompleteAddress from '../AutoCompleteAddress/AutoCompleteAddress.tsx';

function AddressInput({
  field,
  label,
  formData,
  onChange,
  errorField,
  disabled,
  viewMode,
  errorMessages,
}) {
  const [addressValue, setAddressValue] = useState(null);
  const [addressInputValue, setAddressInputValue] = useState('');
  const [country, setCountry] = useState(formData[field.names.country]);

  const resetAddress = (withCountry = false) => {
    Object.keys(field.names).forEach((name) => {
      if (name === field.names.country && !withCountry) {
        return;
      }
      onChange(field.names[name], '');
    });
    setAddressInputValue('');
    setAddressValue('');
  };

  const handleCountryChange = (inputName, newValue) => {
    if (newValue !== country) {
      resetAddress();
    }
    setCountry(newValue);
    onChange(inputName, newValue);
  };

  const handleAddressChange = (data) => {
    const { components } = data;

    setCountry(components.country);
    onChange(field.names.country, components.country);
    onChange(field.names.postalCode, components.postal_code);
    onChange(
      field.names.state,
      components.country === 'US'
        ? states.find((s) => s.text === components.state)?.value
        : components.state,
    );

    onChange(
      field.names.addressLine1,
      components.street_number
        ? `${components.street_number} ${components.address_line_1}`
        : components.address_line_1,
    );
    onChange(field.names.city, components.city);
  };

  return (
    <>
      <SelectInput
        key={field.names.country}
        inputName={field.names.country}
        label="Country"
        formData={formData}
        onChange={handleCountryChange}
        error={errorField.includes(field.names.country)}
        required
        options={countries.map((c) => ({
          value: c.value,
          label: c.text,
        }))}
        viewMode={viewMode}
        disabled={disabled}
      />
      {!viewMode && (
        <AutoCompleteAddress
          label={label}
          country={country}
          disabled={disabled}
          onChange={handleAddressChange}
          value={addressValue}
          onSelectSuggestion={setAddressValue}
          fieldInputValue={addressInputValue}
          onFieldInputValueChange={setAddressInputValue}
        />
      )}
      <>
        <InternalTextField
          key={field.names.addressLine1}
          inputName={field.names.addressLine1}
          label="Address Line 1"
          formData={formData}
          onChange={onChange}
          disabled={disabled}
          viewMode={viewMode}
          errorText={errorMessages[field.names.addressLine1]}
          error={errorField.includes(field.names.addressLine1)}
          required
        />
        <InternalTextField
          key={field.names.addressLine2}
          inputName={field.names.addressLine2}
          label="Address Line 2"
          formData={formData}
          onChange={onChange}
          disabled={disabled}
          viewMode={viewMode}
          errorText={errorMessages[field.names.addressLine2]}
          error={errorField.includes(field.names.addressLine2)}
        />
        {country === 'US' ? (
          <SelectInput
            key={field.names.state}
            inputName={field.names.state}
            label="State"
            formData={formData}
            onChange={onChange}
            error={errorField.includes(field.names.state)}
            disabled={disabled}
            multiple={false}
            viewMode={viewMode}
            options={states.map((state) => ({
              value: state.value,
              label: state.text,
            }))}
            required
          />
        ) : (
          <InternalTextField
            key={field.names.state}
            inputName={field.names.state}
            label="State/Province"
            formData={formData}
            onChange={onChange}
            disabled={disabled}
            viewMode={viewMode}
            errorText={
              errorMessages[field.names.state]
                ? [errorMessages[field.names.state][0]]
                : errorMessages[field.names.state]
            }
            error={errorField.includes(field.names.state)}
            required
          />
        )}
        <InternalTextField
          key={field.names.city}
          inputName={field.names.city}
          label="City"
          formData={formData}
          onChange={onChange}
          disabled={disabled}
          viewMode={viewMode}
          errorText={errorMessages[field.names.city]}
          error={errorField.includes(field.names.city)}
          required
        />
        <InternalTextField
          key={field.names.postalCode}
          inputName={field.names.postalCode}
          label="Postal/ZIP Code"
          formData={formData}
          onChange={onChange}
          disabled={disabled}
          viewMode={viewMode}
          errorText={errorMessages[field.names.postalCode]}
          error={errorField.includes(field.names.postalCode)}
          required
        />
      </>
    </>
  );
}

export default AddressInput;
